import { fetchAuction } from '../api/auction';

import { GET_AUCTION } from '../constants/auction';

export const getAuction = (options) => async (dispatch) => {
  const auctionData = await fetchAuction(options);
  dispatch({
    type: GET_AUCTION,
    payload: auctionData
  });
};
